import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRoot } from "../../../context/root";
import { filters } from "./utils";

export const useFiltersChip = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const { rootDispatch } = useRoot();
  const { geohash } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const getSelectedFilters = () => {
    return {
      ...Object.keys(Object.fromEntries(searchParams)).reduce((acc: any, cur: any) => {
        const filter = filters.find((each) => each.name === cur);
        if (filter) {
          if (["is_recommended", "is_premium", "is_claimed"].includes(cur)) {
            return {
              ...acc,
              [cur]: {
                label: filter.label,
                value: "",
                paramName: filter.name
              }
            }
          }
          return {
            ...acc,
            [cur]: {
              label: `${filter.label}: `,
              value: Object.fromEntries(searchParams)[cur],
              paramName: filter.name
            }
          }
        }
        return {
          ...acc
        }
      }, {})
    }
  }

  const removeFilter = (value: { paramName: string }) => {
    const { paramName } = value;
    searchParams.delete(paramName);
    navigator({
      pathname: location.pathname,
      search: searchParams.toString()
    })
    rootDispatch({
      type: "setRefetch",
      data: {
        shouldRefetch: true,
        geohash: geohash || null
      }
    })
  }

  return {
    savedFilters: Object.values(getSelectedFilters()),
    removeFilter
  }
}